<template>
  <v-row>
    <v-col class="px-6">
      <v-card elevation="4" width="100%">
        <v-card-title>
          <span>
            Urls and total visits
          </span>
          <v-spacer />
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="items"
              label="Time Frame"
              :value="items[2]"
              v-model="item"
              @change="getUrl()"
              solo
            ></v-select> </v-col
          ><v-spacer />
          <v-img
            max-height="100"
            max-width="200"
            contain
            class="mx-auto"
            :src="require('../assets/google-analytics-logo.jpg')"
          ></v-img>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="mostVisitedPages"
          :items-per-page="10"
          :loading="loading"
        ></v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { axios } from '../utils'
export default {
  data() {
    return {
      items: ['Last 30 days', 'Last 7 days', 'Today'],
      loading: false,
      item: 'Today',
      headers: [
        {
          text: 'Pages',
          align: 'start',
          sortable: true,
          value: 'url'
        },
        {
          text: 'Views',
          align: 'start',
          sortable: true,
          value: 'pageViews'
        }
      ],
      mostVisitedPages: []
    }
  },
  mounted() {
    this.getUrl('Today')
  },
  methods: {
    getUrl() {
      let dayNum = {
        Today: 1,
        'Last 7 days': 7,
        'Last 30 days': 30
      }
      let num = dayNum[this.item]
      axios
        .get(`/api/admin/analytics/visited-pages/${num}`)
        .then(({ data }) => (this.mostVisitedPages = data))
        .then(err => console.log(err))
    }
  }
}
</script>

<style></style>
